import { setAlert } from "action";
import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import API from "api";
import Section from "./Section";
import NetworkManager from "./NetworkManager";

const Questions = ({
  mockData,
  setMockData,
  soundArr,
  routeState,
  timerRef,
  onFunctionsReady,
  currentQuestionRef,
}) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const functionsRegisteredRef = React.useRef(false);

  const handleLoadingNextQuestion = useCallback(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);

  const nextQuestion = useCallback(async (obj) => {
    handleLoadingNextQuestion();

    let obj2 = {
      data: obj.data,
      text_answer: obj.answer,
      length: obj.length,
      correct: obj.correct,
      second: obj.time,
      lang: obj.lang,
      html: obj.html,
      audio_text: obj.audio_text,
      duration: obj.duration,
      strategy: mockData.result.strategy,
    };
    let obj1 = finalObjectCreation(obj2);
    finalSubmit(obj1);

    if (mockData.nextType === 1 || mockData.nextType === 2) {
      submitFailed();

      setMockData((prevState) => {
        return {
          ...prevState,
          stopRecording: false,
          modal: false,
          dashboardFlag: true,
          complete: mockData.nextType === 1 ? 1 : 0,
        };
      });
      dispatch(
        setAlert({
          flag: true,
          type: 1,
          message: "Mock submitted successfully",
        })
      );
    } else {
      let soundStat = true;
      const nextQuestion = mockData.questionData[mockData.currentQuestion + 1];
      if (!nextQuestion) {
        console.error("No next question available");
        return;
      }
      if (soundArr.includes(nextQuestion.subcategory_id)) {
        soundStat = false;
      }
      let currentStrategy = mockData.result.strategy;
      let questionTimeData = { isQuestionTime: false };
      let { time } = timerRef.current.timerData();
      let { second: timeToDeduct } = obj1;

      // Deduct time for subcategory 6,7
      if (timeToDeduct) {
        time = time - timeToDeduct;
        if (time < 1) {
          time = 1;
        }
      }

      setMockData((prevState) => {
        const type = prevState.questionData[prevState.currentQuestion + 1].subcategory_id;
        const categoryData = prevState.categoriesData.find(
          (value) => value.question_sub_category_id === type
        );
        let { time_for_each_question: questionTime } = categoryData || {};

        if (questionTime) {
          if (time < questionTime * 60) {
            questionTime = time / 60;
          }
          questionTimeData = {
            isQuestionTime: true,
            questionTime,
          };
        }

        const newQuestionIndex = prevState.currentQuestion + 1;
        if (currentQuestionRef) {
          currentQuestionRef.current = newQuestionIndex;
        }

        return {
          ...prevState,
          soundStat,
          stopRecording: false,
          result: {
            strategy: currentStrategy,
          },
          currentQuestion: newQuestionIndex,
          type,
          ...questionTimeData,
          modal: false,
          // secondCount: time,
          // nextType: 0,
        };
      });
    }
  }, [
    handleLoadingNextQuestion,
    mockData.result,
    mockData.nextType,
    soundArr,
    mockData.questionData,
    mockData.currentQuestion,
  ]);

  // const submitFailed = () => {
  //   let data = [];
  //   let formData = new FormData();
  //   mockData.failed.forEach((value, index) => {
  //     let object = {};
  //     value.forEach((value, key) => {
  //       if (key === "file[]") {
  //         formData.append("files[]", value);
  //       } else {
  //         object[key] = value;
  //         formData.append(`data[${index}][${key}]`, value);
  //       }
  //     });
  //     data.push(object);
  //   });
  //   setTimeout(() => {
  //     API({
  //       method: "POST",
  //       url: "submitFailed/mock",
  //       data: formData,
  //     })
  //       .then((data) => {
  //         console.log('API response received:', data);
  //         // Stop timer after submitFailed completes
  //         console.log("[QUESTIONS] Setting stopTimer flag after submitFailed");
  //         setMockData((prevState) => {
  //           return {
  //             ...prevState,
  //             stopTimer: true
  //           };
  //         });
  //       })
  //       .catch((error) => {
  //         console.error('API call failed:', error);
  //         // Stop timer even on error
  //         setMockData((prevState) => {
  //           return {
  //             ...prevState,
  //             stopTimer: true
  //           };
  //         });
  //       });
  //   }, 2000);
  // };
  
  const submitFailed = async () => {
  const failedRequests = NetworkManager.getFailedRequests();
  if (failedRequests.length === 0) return;

  let formData = new FormData();
  
  failedRequests.forEach((request, index) => {
    const requestFormData = request.data;
    for (let [key, value] of requestFormData.entries()) {
      if (key === 'file[]') {
        formData.append('files[]', value);
      } else {
        formData.append(`data[${index}][${key}]`, value);
      }
    }
  });

  try {
    await NetworkManager.submitWithRetry({
      method: 'POST',
      url: 'submitFailed/mock',
      data: formData
    });
    
    NetworkManager.clearFailedRequests();
    console.log("[QUESTIONS] Setting stopTimer flag after submitFailed");
    setMockData((prevState) => ({
      ...prevState,
      stopTimer: true
    }));
  } catch (error) {
    console.error("submitFailed API call failed:", error);
    setMockData((prevState) => ({
      ...prevState,
      stopTimer: true
    }));
  }
};

  const finalObjectCreation = React.useCallback((obj1 = false) => {
    let qdata = mockData.questionData[mockData.currentQuestion];
    let response = true;

    if (Object.keys(mockData.result).length === 0) {
      response = true;
    }

    return obj1
      ? {
        ...obj1,
        type: qdata.subcategory_id,
        id: qdata.id,
        response,
        answer: qdata.question,
        script: qdata.audio_script,
        q_ans: qdata.answer,
      }
      : {
        ...mockData.result,
        type: qdata.subcategory_id,
        id: qdata.id,
        response,
        answer: qdata.question,
        script: qdata.audio_script,
        q_ans: qdata.answer,
      };
  }, [mockData.questionData, mockData.currentQuestion, mockData.result]);


  // const finalSubmit = useCallback(
  //   (obj1) => {
  //     let { time: secondCount, qTime } = timerRef.current.timerData();
  //     let { questionData, currentQuestion, pending, complete, nextType, intervalId } = mockData;
  //     let curr = questionData[currentQuestion];

  //     // Check if this is the last question or if timer ran out
  //     if (currentQuestion === questionData.length - 1 || mockData.timeOut) {
  //       complete = 1;
  //       // Set completion state immediately to show finished screen
  //       setMockData((prevState) => {
  //         return {
  //           ...prevState,
  //           dashboardFlag: true,
  //           complete: 1
  //         };
  //       });
  //     }

  //     let obj = [];
  //     let time = secondCount;
  //     obj.push(obj1);
  //     let question = {}; // store questions which are not saved in database.

  //     let mockId = routeState.id;
  //     let bodyFormData = new FormData();
  //     if (routeState.pending == 1) {
  //       bodyFormData.append("result_id", mockId);
  //     }

  //     bodyFormData.append("q_count", questionData.length);
  //     bodyFormData.append("mock_id", mockId);
  //     bodyFormData.append("q_time", qTime);
  //     bodyFormData.append("pending", pending);
  //     bodyFormData.append("curr_q", 0);
  //     bodyFormData.append("complete", complete);
  //     bodyFormData.append("question_number", curr.question_number);

  //     obj.map((v, k) => {
  //       if (v.second) {
  //         time = secondCount - v.second;
  //         if (time < 1) {
  //           time = 1;
  //         }
  //       } else {
  //         time = secondCount;
  //       }
  //       bodyFormData.append("time", mockData?.timeOut ? 0 : time);
  //       bodyFormData.append("response[]", v.response);
  //       bodyFormData.append("device", "website");
  //       if ([1, 2, 3, 4, 5, 21, 22].includes(v.type)) {
  //         bodyFormData.append("answer[]", v.ans);
  //         if (v.data === "" || v.data === undefined) {
  //           bodyFormData.append("file[]", new Blob(["hello worllllllllllllld"]));
  //         } else {
  //           bodyFormData.append("file[]", v.data);
  //         }

  //         // Add strategy only for read-aloud.
  //         if (parseInt(v.type) === 1) {
  //           bodyFormData.set("strategy", v.strategy);
  //         }
  //       } else if ([6, 7].includes(v.type)) {
  //         bodyFormData.append("answer[]", v.q_ans);
  //         bodyFormData.append("file[]", new Blob(["hello worlppppppppppppd"]));
  //       } else if ([8, 9, 10, 11, 12].includes(v.type)) {
  //         bodyFormData.append("answer[]", v.correct);
  //         bodyFormData.append("file[]", new Blob(["hello worlppppppppppppd"]));
  //       } else if ([13, 14, 15, 17, 19, 20, 18, 16].includes(v.type)) {
  //         bodyFormData.append("answer[]", v.correct);
  //         bodyFormData.append("file[]", new Blob(["hello worlppppppppppppd"]));
  //       }
  //       bodyFormData.append("selected[]", v.text_answer);
  //       bodyFormData.append("text[]", v.answer);
  //       bodyFormData.append("type[]", v.type);
  //       bodyFormData.append("id[]", v.id);
  //       bodyFormData.append("duration[]", v.duration);
  //       bodyFormData.append("script[]", v.script);
  //       bodyFormData.append("q_ans[]", v.q_ans);
  //       bodyFormData.append("audio_text[]", v.audio_text);
  //       bodyFormData.append("html[]", v.html);
  //       bodyFormData.append("text_answer[]", v.text_answer);
  //       bodyFormData.append("length[]", v.length);
  //       bodyFormData.append("lang[]", v.lang);
  //       bodyFormData.append("correct[]", v.correct);
  //       bodyFormData.append("ans[]", v.q_ans);

  //       question = missingQuestionData(question, v);
  //     });

  //     API({
  //       method: "POST",
  //       url: "submit/mock",
  //       data: bodyFormData,
  //     })
  //       .then((data) => {
  //         let filteredAry = mockData.ids.filter(function (e) {
  //           return e.id !== obj[0].id;
  //         });

  //         setMockData((prevState) => {
  //           return {
  //             ...prevState,
  //             secondCount: time,
  //             qTime: 0,
  //             ids: filteredAry,
  //           };
  //         });

  //         if (data.status !== 200 && data.data.status !== 200) {
  //           setMockData((prevState) => {
  //             return { ...prevState, submitProcess: false };
  //           });
  //           dispatch(
  //             setAlert({ flag: true, type: 2, message: "Something went wrong." })
  //           );
  //         }
  //         // Call submitFailed if test is complete
  //         if (complete === 1) {
  //           submitFailed();
  //           setMockData((prevState) => {
  //             return {
  //               ...prevState,
  //               answer_submitted: true,
  //               failed_submitted: true
  //             };
  //           });
  //         }
  //         // Stop timer after API completion for submit or save & exit
  //         if (nextType === 1 || nextType === 2) {
  //           // console.log("[QUESTIONS] Stopping timer - intervalId:", intervalId, "nextType:", nextType);
  //           // if (intervalId) {
  //           //   clearInterval(intervalId);
  //           //   console.log("[QUESTIONS] Timer stopped successfully");
  //           // } else {
  //           //   console.log("[QUESTIONS] WARNING: No intervalId found!");
  //           // }
  //            console.log("[QUESTIONS] Setting stopTimer flag after submit completion");
  //            setMockData((prevState) => ({
  //            ...prevState,
  //            stopTimer: true
  //            }));
  //         }
  //       })
  //       .catch(() => {
  //         let arr = [];
  //         arr = mockData.failed;
  //         arr.push(bodyFormData);
  //         setMockData((prevState) => {
  //           return { ...prevState, failed: arr };
  //         });
  //       });
  //   }, [mockData, routeState, timerRef, dispatch]
  // )
  
  const finalSubmit = useCallback(
  async (obj1) => {
    let { time: secondCount, qTime } = timerRef.current.timerData();
    let { questionData, currentQuestion, pending, complete, nextType } = mockData;
    let curr = questionData[currentQuestion];

    if (currentQuestion === questionData.length - 1 || mockData.timeOut) {
      complete = 1;
      setMockData((prevState) => ({
        ...prevState,
        dashboardFlag: true,
        complete: 1
      }));
    }

    let obj = [];
    let time = secondCount;
    obj.push(obj1);
    let question = {};

    let mockId = routeState.id;
    let bodyFormData = new FormData();
    if (routeState.pending == 1) {
      bodyFormData.append("result_id", mockId);
    }

    bodyFormData.append("q_count", questionData.length);
    bodyFormData.append("mock_id", mockId);
    bodyFormData.append("q_time", qTime);
    bodyFormData.append("pending", pending);
    bodyFormData.append("curr_q", 0);
    bodyFormData.append("complete", complete);
    bodyFormData.append("question_number", curr.question_number);

    obj.map((v, k) => {
      if (v.second) {
        time = secondCount - v.second;
        if (time < 1) {
          time = 1;
        }
      } else {
        time = secondCount;
      }
      bodyFormData.append("time", mockData?.timeOut ? 0 : time);
      bodyFormData.append("response[]", v.response);
      bodyFormData.append("device", "website");
      if ([1, 2, 3, 4, 5, 21, 22].includes(v.type)) {
        bodyFormData.append("answer[]", v.ans);
        if (v.data === "" || v.data === undefined) {
          bodyFormData.append("file[]", new Blob(["hello worllllllllllllld"]));
        } else {
          bodyFormData.append("file[]", v.data);
        }
        if (parseInt(v.type) === 1) {
          bodyFormData.set("strategy", v.strategy);
        }
      } else if ([6, 7].includes(v.type)) {
        bodyFormData.append("answer[]", v.q_ans);
        bodyFormData.append("file[]", new Blob(["hello worlppppppppppppd"]));
      } else if ([8, 9, 10, 11, 12].includes(v.type)) {
        bodyFormData.append("answer[]", v.correct);
        bodyFormData.append("file[]", new Blob(["hello worlppppppppppppd"]));
      } else if ([13, 14, 15, 17, 19, 20, 18, 16].includes(v.type)) {
        bodyFormData.append("answer[]", v.correct);
        bodyFormData.append("file[]", new Blob(["hello worlppppppppppppd"]));
      }
      bodyFormData.append("selected[]", v.text_answer);
      bodyFormData.append("text[]", v.answer);
      bodyFormData.append("type[]", v.type);
      bodyFormData.append("id[]", v.id);
      bodyFormData.append("duration[]", v.duration);
      bodyFormData.append("script[]", v.script);
      bodyFormData.append("q_ans[]", v.q_ans);
      bodyFormData.append("audio_text[]", v.audio_text);
      bodyFormData.append("html[]", v.html);
      bodyFormData.append("text_answer[]", v.text_answer);
      bodyFormData.append("length[]", v.length);
      bodyFormData.append("lang[]", v.lang);
      bodyFormData.append("correct[]", v.correct);
      bodyFormData.append("ans[]", v.q_ans);

      question = missingQuestionData(question, v);
    });

    try {
      const data = await NetworkManager.submitWithRetry({
        method: "POST",
        url: "submit/mock",
        data: bodyFormData,
      });

      let filteredAry = mockData.ids.filter(function (e) {
        return e.id !== obj[0].id;
      });

      setMockData((prevState) => ({
        ...prevState,
        secondCount: time,
        qTime: 0,
        ids: filteredAry,
      }));

      if (data.status !== 200 && data.data.status !== 200) {
        setMockData((prevState) => ({ ...prevState, submitProcess: false }));
        dispatch(setAlert({ flag: true, type: 2, message: "Something went wrong." }));
      }

      if (complete === 1) {
        setTimeout(() => {
          submitFailed();
        }, 2000);
        setMockData((prevState) => ({
          ...prevState,
          answer_submitted: true,
          failed_submitted: true
        }));
      }

      if (nextType === 1 || nextType === 2) {
        console.log("[QUESTIONS] Setting stopTimer flag after submit completion");
        setMockData((prevState) => ({
          ...prevState,
          stopTimer: true
        }));
      }
    } catch (error) {
      console.error("Submission failed, added to retry queue:", error);
    }
  }, [mockData, routeState, timerRef, dispatch]
);

  const missingQuestionData = useCallback((question, response) => {
    question.text = response.answer;
    question.selected = response.text_answer;
    question.text_answer = response.text_answer;
    question.type = response.type;
    question.lang = response.lang;
    question.script = response.script;
    question.html = response.html;
    question.correct = response.correct;
    question.length = response.length;
    question.id = response.id;
    question.audio_text = response.audio_text;
    question.q_ans = response.q_ans;
    question.duration = response.duration;
    question.ans = response.q_ans;
    question.device = "website";
    question.response = response.response;

    if ([1, 2, 3, 4, 5, 21, 22].includes(response.type)) {
      question.answer = response.ans;
      question.file =
        response.data !== undefined && response.data !== ""
          ? response.data
          : new Blob(["hello worllllllllllllld"]);
    } else if ([6, 7].includes(response.type)) {
      question.answer = response.q_ans;
      question.file = new Blob(["hello worlppppppppppppd"]);
    } else if ([8, 9, 10, 11, 12].includes(response.type)) {
      question.answer = response.correct;
      question.file = new Blob(["hello worlppppppppppppd"]);
    } else if ([13, 14, 15, 17, 19, 20, 18, 16].includes(response.type)) {
      question.answer = response.correct;
      question.file = new Blob(["hello worlppppppppppppd"]);
    }
    return question;
  }, []);

  const soundChecked = useCallback(() => {
    setMockData((prevState) => {
      return { ...prevState, soundStat: true };
    });
  }, []);

  const submitResponse = useCallback((data, f = false) => {
    let obj = {
      data: data.data,
      textAnswer: data.answer,
      length: data.length,
      correct: data.correct,
    };
    if (f) {
    } else {
      setMockData((prevState) => {
        return { ...prevState, result: obj };
      });
    }
  }, [])

  const resultStatus = useCallback(() => {
    setMockData((prevState) => {
      return { ...prevState, isResult: true };
    });
  }, []);

  const setStrategy = (st) => {
    const r = { ...mockData.result };
    r.strategy = st;
    setMockData((prevState) => {
      return {
        ...prevState,
        result: r,
      };
    });
  };

  const nextQuestionHandler = () => {
    // if mock is timed out then do not process further
    if (mockData.timeOut) {
      return;
    }

    setMockData((prevState) => {
      return { ...prevState, stopRecording: true };
    });
  };

  //   React.useEffect(() => {
  //   if (onFunctionsReady) {
  //     onFunctionsReady({ finalObjectCreation, finalSubmit });
  //   }
  // }, [onFunctionsReady,finalObjectCreation,finalSubmit]);
  React.useEffect(() => {
    // Update currentQuestionRef whenever currentQuestion changes
    if (currentQuestionRef) {
      currentQuestionRef.current = mockData.currentQuestion;
    }
  }, [mockData.currentQuestion]);

  React.useEffect(() => {
    if (!onFunctionsReady || functionsRegisteredRef.current) return;

    onFunctionsReady({
      finalObjectCreation,
      finalSubmit,
    });

    functionsRegisteredRef.current = true;
  }, [onFunctionsReady, finalObjectCreation, finalSubmit]);

  const data = {
    submit: submitResponse,
    showResult: resultStatus,
    data: mockData.questionData[mockData.currentQuestion],
    resultMode: false,
    testMode: true,
    soundChecked: soundChecked,
    stopRecording: mockData.stopRecording,
    nextQuestion: nextQuestion,
    strategy: mockData.result.strategy,
    setStrategy: setStrategy,
    isQuestionTime: mockData.isQuestionTime,
    questionTime: mockData.questionTime,
    nextQuestionHandler: nextQuestionHandler,
  };

  return (
    <>
      {/* {mockData.timeOut && <div className="m-3">Test stopped due to timeout.</div>} */}
      <Section
        mockData={mockData}
        data={data}
        loading={loading}
      />
    </>
  );
};

export default Questions;
